import React from 'react'

function Asterisk(props) {
    return (
        <span style={props.color==='red' ? { color: 'red', marginRight: 5 } : { color: 'black', marginRight: 5 }}>
            {props.text || '*'}
        </span>
    )
}

export default Asterisk